import React from 'react';

export const RuTroughModal = {
  title: 'Maximum Trough Height (meters)',
  body: (
    <div>
      <p>
        The maximum water trough below sea level in meters. Trough is the lowest part of a wave.
      </p>
    </div>
  ),
};
